module.exports = __webpack_public_path__ + "img/6.42399d85.jpg";